import { j as e } from "./index58.mjs";
import { Skeleton as o } from "@mantine/core";
const i = (t) => {
  const n = {
    ...t
  };
  return t.visible ? /* @__PURE__ */ e.jsx(o, { ...n, ...t }) : /* @__PURE__ */ e.jsx(e.Fragment, {});
};
export {
  i as Skeleton
};
